import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * LoginCard — приподнятая карточка экрана входа (`.login-card` макета): радиус 16, тень из токена,
 * ограниченная ширина, центрирование. Логика авторизации — вне дизайн-системы (cabinet-design-sync).
 */
export const LoginCard = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'mx-auto w-full max-w-login rounded-16 border border-line bg-white px-7 py-8 shadow-elevated',
        className,
      )}
      {...props}
    />
  ),
)
LoginCard.displayName = 'LoginCard'
